import axios from 'axios'
import store from '@/store'
import router from '@/router'
import apiConfig from '../../config/api.config.js'
import { MessageBox, Message } from 'element-ui'
// import { getToken } from '@/utils/auth'

const service = axios.create({
  baseURL: apiConfig.baseUrl,
  withCredentials: true, // 跨域请求时发送 cookies
  timeout: 9000
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 发送请求前做处理
    // if (store.getters.token) {
    // 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改
    // config.headers['X-Token'] = getToken()
    config.headers['X-Requested-With'] = 'XMLHttpRequest' // 解决后端无法区分isAjax的问题
    // }
    // if (config.url.indexOf('http') >= 0) {
    //   delete config.baseURL
    // }
    return config
  },
  error => {
    // Do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    if (res.code !== 20000 && res.code !== '20000') {
      Message({
        message: res.message || 'error',
        type: 'error',
        duration: 5 * 1000
      })
      if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
        MessageBox.confirm('登录超时请重新登录', '警告', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          store.dispatch('user/logout')
          router.push({ path: '/login' })
        }).catch(() => {
          store.dispatch('user/logout')
          router.push({ path: '/' })
        })
      }
      return Promise.reject(res.message || 'error')
    } else {
      return res
    }
  }
)
export default service



// WEBPACK FOOTER //
// ./src/utils/request.js